import RoleBasedLayout from "./RoleBasedLayout";
import PayRollPage from "../ui/PayRollPage";

export default function PayRoll() {

    return (
        <RoleBasedLayout>
            <PayRollPage />
        </RoleBasedLayout>
    );
}